/**
 * Same inputs, by value: primitives and functions by identity, plain data
 * (the arrays/objects callers rebuild on every render, e.g. `rows.map(...)`)
 * structurally. Charts are small, so the JSON compare is cheap.
 */
export function sameInputs(a: readonly unknown[] | null, b: readonly unknown[]): boolean {
  if (!a || a.length !== b.length) return false;
  return a.every((value, i) => {
    const other = b[i];
    if (Object.is(value, other)) return true;
    if (typeof value !== 'object' || typeof other !== 'object' || !value || !other) return false;
    try {
      return JSON.stringify(value) === JSON.stringify(other);
    } catch {
      return false;
    }
  });
}
